import script from "./OfLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./OfLogin.vue?vue&type=script&setup=true&lang=js"

import "./OfLogin.vue?vue&type=style&index=0&id=0503428f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0503428f"]])

export default __exports__